import React from 'react';
import { render } from 'react-dom';
import SiteSearch from './apps/SiteSearch/SiteSearch';

// SiteSearch Application
const site_search = document.getElementById('app-instant-search');
if (site_search) render(<SiteSearch {...site_search.dataset} />, site_search);
